import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { TacticType } from "@front/m19-api-client";
import { SegmentEx, StrategyEx } from "@front/m19-models";
import { IBadgeComponent } from "@front/m19-ui";

@Component({
  selector: "app-strategy-grid-targetings",
  template: `
    <ng-container *transloco="let t">
      @if (audienceTargetings(); as audienceTargetings) {
        @if (audienceTargetings.length === 0 && numberOfTactics() === 0) {
          <IBadge color="gray" [label]="t('targetings-renderer.no_targeting')" />
        } @else {
          <IBadge
            color="white"
            [label]="t('targetings-renderer.number_targetings', [audienceTargetings.length + numberOfTactics()])"
          />
        }
      }
    </ng-container>
  `,
  imports: [TranslocoDirective, IBadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyGridTargetingsComponent {
  strategy = input.required<StrategyEx>();
  segmentIndex = input.required<Map<number, SegmentEx>>();

  audienceTargetings = computed(() => {
    const strategy = this.strategy();
    return strategy.isSdStrategy() && strategy.isAdvertisingStrategy() ? strategy.audienceTargetings : undefined;
  });

  numberOfTactics = computed<number>(() => {
    const strategy = this.strategy();

    if (!strategy.isAdvertisingStrategy()) return 0;

    let numberOfTactics = strategy.autoAlgoExplorationEnabled ? 1 : 0;
    numberOfTactics += strategy.tactics
      .filter((t) => t.tacticType == TacticType.LEGACY)
      .map((t) => this.segmentIndex().get(t.segmentId)!).length;

    return numberOfTactics;
  });
}
